/*global define:false*/
define('plugins/boolean/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({
        });

    });

